// Vidaloka (regular only)
export const vidalokaFont = {
  family: 'Vidaloka',
  src: '/free-resources/fonts/Vidaloka-Regular.ttf',
};

// Montserrat (all weights & italics)
export const montserratFont: any = {
  family: 'Montserrat',
  fonts: [
    {
      src: '/free-resources/fonts/Montserrat-Thin.ttf',
      fontWeight: 100,
      fontStyle: 'normal',
    },
    {
      src: '/free-resources/fonts/Montserrat-ThinItalic.ttf',
      fontWeight: 100,
      fontStyle: 'italic',
    },
    {
      src: '/free-resources/fonts/Montserrat-ExtraLight.ttf',
      fontWeight: 200,
      fontStyle: 'normal',
    },
    {
      src: '/free-resources/fonts/Montserrat-ExtraLightItalic.ttf',
      fontWeight: 200,
      fontStyle: 'italic',
    },
    {
      src: '/free-resources/fonts/Montserrat-Light.ttf',
      fontWeight: 300,
      fontStyle: 'normal',
    },
    {
      src: '/free-resources/fonts/Montserrat-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/free-resources/fonts/Montserrat-Regular.ttf',
      fontWeight: 400,
      fontStyle: 'normal',
    },
    {
      src: '/free-resources/fonts/Montserrat-Italic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    {
      src: '/free-resources/fonts/Montserrat-Medium.ttf',
      fontWeight: 500,
      fontStyle: 'normal',
    },
    {
      src: '/free-resources/fonts/Montserrat-MediumItalic.ttf',
      fontWeight: 500,
      fontStyle: 'italic',
    },
    {
      src: '/free-resources/fonts/Montserrat-SemiBold.ttf',
      fontWeight: 600,
      fontStyle: 'normal',
    },
    {
      src: '/free-resources/fonts/Montserrat-SemiBoldItalic.ttf',
      fontWeight: 600,
      fontStyle: 'italic',
    },
    {
      src: '/free-resources/fonts/Montserrat-Bold.ttf',
      fontWeight: 700,
      fontStyle: 'normal',
    },
    {
      src: '/free-resources/fonts/Montserrat-BoldItalic.ttf',
      fontWeight: 700,
      fontStyle: 'italic',
    },
    {
      src: '/free-resources/fonts/Montserrat-ExtraBold.ttf',
      fontWeight: 800,
      fontStyle: 'normal',
    },
    {
      src: '/free-resources/fonts/Montserrat-ExtraBoldItalic.ttf',
      fontWeight: 800,
      fontStyle: 'italic',
    },
    {
      src: '/free-resources/fonts/Montserrat-Black.ttf',
      fontWeight: 900,
      fontStyle: 'normal',
    },
    {
      src: '/free-resources/fonts/Montserrat-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
};
